import React from "react";

interface CardProps {
  className?: string;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({ className = "", children, onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`bg-white dark:bg-gray-800 p-8 rounded-2xl border border-transparent dark:border-gray-700 ${className} ${
        onClick ? "cursor-pointer" : ""
      }`}
    >
      {children}
    </div>
  );
};

export default Card;
